/**
 * Estado global de abertura do LeadExplorer (vários pontos de entrada: página do LeadExplorer,
 * card da home, clique em CNPJ nas tabelas). O host é renderizado no AppShell.
 */
import { create } from 'zustand';

interface LeadExplorerState {
  open: boolean;
  /** Termo inicial (CNPJ/domínio) — abre já pesquisando, como mountLeadExplorer(term). */
  term: string | null;
  /**
   * Com o termo, pesquisa na hora (padrão). Falso: só preenche o campo e espera a pessoa
   * confirmar em Analisar (menu do site e do CNPJ nas tabelas, 24/10/2026).
   */
  run: boolean;
  /** Análise guardada no histórico: abre direto no resultado, sem nova consulta. */
  savedId: string | null;
  openExplorer: (term?: string, options?: { run?: boolean }) => void;
  openSaved: (id: string) => void;
  closeExplorer: () => void;
}

export const useLeadExplorerStore = create<LeadExplorerState>((set) => ({
  open: false,
  term: null,
  run: true,
  savedId: null,
  openExplorer: (term, options) =>
    set({ open: true, term: term ?? null, run: options?.run ?? true, savedId: null }),
  openSaved: (id) => set({ open: true, term: null, run: true, savedId: id }),
  closeExplorer: () => set({ open: false, term: null, run: true, savedId: null }),
}));
